export default __webpack_public_path__ + "static/media/banner-1.758d1304.png";